import { render, staticRenderFns } from "./printstories.vue?vue&type=template&id=28f242b3"
import script from "./printstories.vue?vue&type=script&lang=js"
export * from "./printstories.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports